const parsePageName = (name: string) =>
  name.replace(/^\//, '').replace(/[\/-]/g, ' ');

export default parsePageName;
